<template>
	<div class="dashboard_container" style="min-width: 1310px;">

	  <div class="tfa-dashboard-section cn-dashboard-section">
	  <div class="top-section row">
	    <div class="dashboard-row stream-section col-12" style="max-width: 100%;">
	      <div class="">

	        <div class="card" style="min-height: 475px !important; min-width: 846px;">
	      		<div class="card-header">
	        		<span class="icon ico-summary" style="font-size: 50px; margin: -7px 10px 0px -5px;"></span>
	        		<span class="label" role="heading" aria-level="1">{{username}}'s Summary</span>

	        		<div class="legend-popup"><div class="btn_legends" aria-label="progress legend">

	              	</div>
	            </div>

	          </div>
				<div class="card-body">
					<div class="sub-header">
						<div class="left-head">
							<!--
							<span class="label">Main Set of Quests</span>
							<span class="icon icon-dropdown2"></span>
							-->
						</div>
						<div class="right-col">
							<div class="coach-col">
								<div class="summary_sec_row" v-if="careerGoal" :title="careerGoal" tabindex="0"><span class="label">Career Goal: {{careerGoal}}</span></div>
	                            <div class="summary_sec_row" v-if="advisorName" :title="advisorName" tabindex="0"><span class="label">Coach: <strong>{{advisorName}}</strong></span></div>
							</div>
						</div>
					</div>
					 <div class="right-tab-col">
						    	<div class="row career-sum-sec">

					            	<div class="career-sec col-6">
					            		<div class="inner-sec">
						            		<div class="header"><span class="icon ico-quest"></span> <span class="head_text">My Quests</span></div>
						            		<div class="content-sec quest_list">
                                                <template v-for="(quest, index) in quests">
                                                    <b-link class="mb-3 d-block" :class="currentQuest(quest)" @click="goToCareerQuest(quest)" :id="'quest_' + index">
                                                    	<span class="ic_container">
	                                                    	<span class="ico-lock"></span>
	                                                    	<span class="ico-unlock"></span>
	                                                    	<span class="ico-continue"></span>
                                                    	</span>
                                                    	<span class="title">{{quest.titleForStudent}}</span>
                                                    </b-link>
                                                </template>
						            		</div>
						            		<!--
						            		<div class="links" @click="continueCareerQuest()">
						            			<span style="float: right;">continue career quests</span>
						            		</div>
						            		-->
						            	</div>
					            	</div>

					            	<div class="career-sec connection-col col-6">
					            		<div class="inner-sec">
						            		<div class="header">
						            			<span class="icon icon-job"></span><span class="head_text">My Career Ideas</span>
						            			<div v-if="planningStream !== undefined && planningStream.enableCareerIdea">
				                              		<b-link :to="{ name: 'careerIdeaCreate' }" class="btn" style="float: right; margin-right: 8px; margin-top: 7px;">
				                                		<span class="long_txt" style="color: #fff;">add career idea</span>
				                                		<span class="short_txt" style="color: #fff;">add</span>
				                              		</b-link>
				                            	</div>
						            		</div>
						            		<div class="content-sec">

						            		  	<div class="career-lock-section" v-if="planningStream == undefined || !planningStream.enableCareerIdea">
						            		  		<div class="lock_msg_container">
						            		  			<span class="ic ico-lock"></span>
						            		  			<!--
						            		  			<span class="lock-text">Career idea is currently locked, it will be unlocked after completing the quest 5</span>
						            		  			-->
						            		  		</div>
						            		  	</div>

						            		  	<career-idea-list :is-career-idea-enable="planningStream !== undefined && planningStream.enableCareerIdea"></career-idea-list>

						            		  	<!--
						            			<div class="content-row" v-for="ci in careerIdeas">
						            				<div class="label-sec" :title="ci.title">{{ci.title}}</div>
						            				<div class="right-col">
						            					<div class="column">
							            					<span class="icon ico-connection1"></span>
							            					<span class="count" style="vertical-align: top;">{{ci.connectionCount}}</span>
							            					<span class="title">Connection</span>
							            				</div>
						            				</div>
						            			</div>
						            			-->

						            		</div>

						            	</div>
					            	</div>
					            </div>
			         </div>
	          </div>
	        </div>
	      </div>
	    </div>

		<div id="notificationPopupContainer" class="notification-popup-container" v-if="!isClearlyNextPackageEnabled"></div>
	    <div class="dashboard-row notifications-panel col-3" v-if="!isClearlyNextPackageEnabled">
	      <div class="">
	        <div class="card" style="min-height: 475px !important;">
	          <div class="card-header">
	            <span class="icon icon-bell"></span>
	            <span class="label" role="heading" aria-level="2">Messages</span>
	          </div>
	          <div class="card-body notification-content-section">
				<div class="msg_row_section msg_row_section_urgent">
		    		<div class="msg_section_inner msg_section_inner_urgent">

			            <template v-for="(message, index) in messages">

			              <b-popover :target="'un_' + index"  triggers="click" :ref="'notificationPopover_' + index" container="notificationPopupContainer">
			        				<div class="header-title">
			        					<span class="icon icon-user"></span>
			        					<span class="user-name">{{message.name}}</span>
			        					<button class="btn_close" @click="closeNotificationPopup(index)">
													<span class="ic-close"></span>
												</button>
			        				</div>
			        				<div class="content-body">
			        					<div class="notifications-row">
			        					  <div class="message-creator-avatar"><span class="icon-user"></span></div>
			        					  <div class="msg-section">
			        						<div class="user-row">
			        						  <span class="user-name-section">{{message.name}}</span>
			        						  <span class="time-section">{{message.date}}</span>
			        						</div>
			        						<div class="msg-row">
			        						  {{message.text}}
			        						</div>
			        					  </div>
			        					</div>
			        				</div>
			        			</b-popover>
			              <div class="notifications-row" :id="'un_' + index" v-if="message.type === 'Urgent Notification'">
			                <div class="message-creator-avatar"><span class="icon-user"></span></div>
			                <div class="msg-section">
			                  <div class="user-row">
			                    <span class="user-name-section">{{message.name}}</span>
			                    <span class="time-section">{{message.date}}</span>
			                  </div>
			                  <div class="msg-row">
			                    {{message.text}}
			                  </div>
			                </div>
			              </div>
			           </template>

					</div>
	           </div>

	          </div>
	        </div>
	      </div>
	    </div>
	  </div>

	  </div>

	</div>
</template>

<script>
  import '../../../assets/module/css/dashboard/tfaDashboard.min.css'
  import { mapState, mapActions } from 'vuex'
  import DummyGraph from './dummyGraph'
  import { db } from '../../../firebase'
  import CareerIdeaList from '../../quest/components/CareerIdeaList'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'clearlyNextStudentDashboard',
    components: {
      DummyGraph,
      CareerIdeaList
    },
    props: ['forceShowProfile'],
    data: () => {
      return {
        uObj: JSON.parse(localStorage.getItem('userobj')),
        page: 0,
        courses: [],
        career: '',
        isDoNotOpenProfilePopup: false,
        lastPage: false,
        quickLinks: [],
        currentChannel: 'Pragya',
        messages: [],
        careerIdeas: [],
        completedQuests: 0,
        continueQuestAction: {},
        quests: []
      }
    },

    mounted () {
      this.loadStudentDashboard()
    },
    created () {
      this.currentChannel = this.planningStream.uuid
      this.$watch('planningStream', (planningStream) => {
        if (planningStream) {
          this.$bindAsArray('messages', db.ref('channels/' + planningStream.uuid + '/Messages'))
        }
      }, {
        immediate: true
      })
    },
    firebase: {
      messages: {
        source: db.ref('channels/' + this.currentChannel + '/Messages'),
        readyCallback: function () {
        },
        cancelCallback: function (e) {
          console.log('Could not get messages', e)
        }
      }
    },

    watch: {
      messages () {
        setTimeout(() => {
          var msgSectionHeight = $('.msg_section_inner_recommendation').innerHeight()
          $('.msg_row_section_recommendation').scrollTop(msgSectionHeight)
          var msgSectionHeight2 = $('.msg_section_inner_urgent').innerHeight()
          $('.msg_row_section_urgent').scrollTop(msgSectionHeight2)
        }, 100)
      }
    },

    methods: {
      ...mapActions([
        'loadQuickLinks',
        'loadEnrolledCourses',
        'loadPlanningStream',
        'loadUserAdvisor',
        'loadUserCareerGoal',
        'loadUserPreferences',
        'loadJobRecommendations',
        'loadLogDashboardActivity',
        'loadSaveProfile',
        'loadInstitutionPackage',
        'loadCareerIdeasForUser',
        'loadCompletedQuests',
        'loadContinueQuestAction',
        'loadCourseTopics',
        'loadIndividualCoacheeStatus'
      ]),
      loadStudentDashboard () {
        this.loadPlanningStream()
        this.loadUserAdvisor(localStorage.getItem('userid'))
        this.loadInstitutionPackage({uuid: this.uObj.institutionId, isAggregated: false}).then(res => {
          this.loadUserPreferences()
        })
        this.loadCareerIdeasForUser({userId: localStorage.getItem('userid'), index: 0}).then(res => {
          if (res && res.data) {
            this.careerIdeas = res.data
          }
        })
        this.loadCompletedQuests().then(res => {
          this.completedQuests = res
        })
        this.loadQuests()
        window.addEventListener('resize', this.handleWindowResize)
      },

      goToCareerQuest (quest) {
        if (quest.status !== -1) {
          return this.$router.push({ name: 'questLearn', params: {uuid: quest.courseId, entityType: 'LearningContent', entityUuid: quest.entityId}, query: {isMainQuest: true} })
        }
      },

      currentQuest (quest) {
        if (quest.status === -1) {
          return 'quest_locked'
        }
        if (quest.status === 0) {
          return 'quest_unlocked'
        } else if (quest.status === 1) {
          return 'current_quest'
        } else {
          return 'quest_complete'
        }
      },

      isClearlyNextPackageEnabled () {
        let clearlyNextFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CLEARLY_NEXT_FEATURE_ID]
        if (clearlyNextFeature && clearlyNextFeature.enabled) {
          return true
        }
        return false
      },

      loadQuests () {
        this.loadIndividualCoacheeStatus().then(res => {
          this.quests = res
        })
      },

      closeNotificationPopup (index) {
        this.$refs['notificationPopover_' + index][0].$emit('close')
      },

      handleWindowResize (event) {
        let routeName = this.$router.currentRoute.name
        if (routeName === 'studentDashboard') {
          this.populateEnrolledCourses()
        }
      },

      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleWindowResize)
      }
    },

    computed: {
      ...mapState({
        'links': state => state.dashboard.quickLinks,
        'planningStream': state => state.dashboard.planningStream,
        'dashboardPlanning': state => state.dashboard.dashboardPlanning,
        'advisor': state => state.user.advisor,
        'jobRecommendations': state => state.dashboard.jobRecommendations,
        'careerGoal': state => state.user.careerGoal,
        'enabledFeatures': state => state.institution.enabledFeatures,
        'linearTopics': state => state.course.linearTopics
      }),
      username () {
        return localStorage.getItem('userFullName')
      },
      advisorName () {
        if (this.advisor) {
          return this.advisor.name
        } else {
          return null
        }
      }
    }
  }
</script>

<style scoped>
    .next {
    	margin-top: 10%;
    }

    .icon-master {
    	float: right !important;
    	margin-top: 0px !important;
    	margin-left: 0px !important;
    }

    .lg_blc {
    	width: 30px;
    	height: 30px;
    	display: inline-block;
    	margin: 0px 17px 0px 15px;
    }

    .status_row {
    	display: flex;
    	align-items: center;
    	height: 45px;
    	margin: 10px 0;
    	min-width: 241px;
    	font-size: 15px;
    }

    .legend-title {
    	padding-left: 15px;
    	font-size: 19px;
    	font-family: robotoSlab_Light;
    	margin-bottom: 17px;
    }

    .icon-progress {
    	font-size: 40px;
    	margin: 0 14px 0 15px;
    }

    .legend-section {
    	height: 46px;
        display: flex;
        align-items: center;
    	float:right;
    }
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/ClearlyNextStudentDashboard.vue